import { JSX } from 'react';
import { MDXComponents } from 'mdx/types.js';
import SocialMedia from '@components/social-media/SocialMedia';


// a, blockquote, br, code, em, h1, h2, h3, h4, h5, h6, hr, img, li, ol, p, pre, strong, and ul
// br, code, h4, h5, h6, li, pre, 


type ElementProps = JSX.IntrinsicElements

const Img = (props: ElementProps["img"]) => <p className='md-img'><img {...props} /></p>


export const components: MDXComponents = {
	img: Img,
	SocialMedia,
}